import React from "react";
import { useStyles } from "./styles";
import { OfferProps } from "./types";
import { RefButton } from "../like-button-ref/like-button-ref";

export const Offer = (props: OfferProps) => {
    const classes = useStyles();

    return (
        <section className={[classes.offerContainer, ...(props.classes || [])].join(' ')}>
            <div className={"h2 " + classes.offerTitle}>
                {props.title}
            </div>
            <RefButton
                text={props.button.text}
                href={props.button.href}
                style={props.button.style}
                variant={props.button.variant}
                size={props.button.size}
                classNames={classes.offerButton}
                target={props.button.target}
            />
        </section>
    );
};
